import type { StageFlag } from '@/config/features';

/** LaunchDarkly can serve any JSON, so only a literal `true` turns a stage on */
export const isStageFlagEnabled = (flag: StageFlag | null) => {
  const env = import.meta.env.VITE_APP_ENV;

  return flag?.[env === 'localhost' ? 'dev' : env] === true;
};
